import { createRoute } from '@tanstack/react-router'
import { Route as settingsLayoutRoute } from './layout'

export const Route = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: '/settings/chart-of-accounts',
}).lazy(() => import('./chart-of-accounts.lazy').then((d) => d.Route))
